<template>
    <div class="transformer">
        <Title firstName="进线电流" lastName="INTO THE LINE CURRENT"/>
        <div class="echarts">
            <div class="tabList" @click="showTransformList">
                {{transform}} <i class="el-icon-arrow-down"></i>
            </div>
            <div class="list" v-show="showList">
                <SelectList :selectList="transformList" @tabTitle="tabTitle" keyk="deviceId" keyval="loopName"/>
            </div>
            <div class="edata">
                <div class="edataCon">
                    <p><span class="span1"></span>A相</p>
                    <p>{{isNaN(Number(mqtt[loopUrl +'/Ia']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Ia']).toFixed(2)}}<span> A</span></p>
                </div>
                <div class="edataCon">
                    <p><span class="span2"></span>B相</p>
                    <p>{{isNaN(Number(mqtt[loopUrl +'/Ib']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Ib']).toFixed(2)}}<span> A</span></p>
                </div>
                <div class="edataCon">
                    <p><span class="span3"></span>C相</p>
                    <p>{{isNaN(Number(mqtt[loopUrl +'/Ic']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Ic']).toFixed(2)}}<span> A</span></p>
                </div>
            </div>
            <div class="eview">
                <Graph :chartId="chartId" unit="A" :color="['#df375b']" :seriesData="allA[0]" :seriesData1="allA[1]" :seriesData2="allA[2]" :xData="xData" v-if="allA[2].length >0"/>
                <div class="noneData" v-else>
                    暂无数据
                </div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../components/title/Title')
const SelectList = () => import('../../components/title/selectList')
const Graph = () => import('../../components/echarts/graph.vue')

import { loopMasterArea } from '../../utils/api'
import { getTodayTime } from '../../utils/common'
import { mapState } from 'vuex'

export default {
    data(){
        return {
            chartId:'intoLine',
            xData:['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00','24:00',],
            seriesData:[120, 200, 10, 180, 70, 210, 130],
            showList:false,
            transform:'#系统电源进线',
            transformList:[],
            loop:{},
            allA:[[],[],[]],
            loopUrl:''
        }
    },
    components:{
        Title,SelectList,Graph
    },
    computed:{
        ...mapState({mqtt:'MQTTObj'})
    },
    mounted(){
        if(this.$store.state.siteId == 26){
            this.getIntoLine()
        }else{
            let allA = [['104.64', '96.96', '90.00', '95.52', '0.00', '94.56', '81.60', '109.68', '141.00', '451.44', '522.72','76.3', '81.36', '83.76', '85.20', '0.00', '61.68', '63.60', '89.28', '77.00', '315.84', '494.16','77.00', '315.84', '494.16'],
                       ['76.3', '81.36', '83.76', '85.20', '0.00', '61.68', '63.60', '89.28', '77.00', '315.84', '494.16','117.60', '114.96', '116.40', '119.28', '0.00', '102.48', '103.20', '113.04', '110.00', '442.56', '558.24','77.00', '315.84', '494.16'],
                       ['117.60', '114.96', '116.40', '119.28', '0.00', '102.48', '103.20', '113.04', '110.00', '442.56', '558.24','76.3', '81.36', '83.76', '85.20', '0.00', '61.68', '63.60', '89.28', '77.00', '315.84', '494.16','110.00', '442.56', '558.24']]
            let hour = new Date().getHours() + 1
            allA[0] =  allA[0].splice(0, hour)
            allA[1] =  allA[1].splice(0, hour)
            allA[2] =  allA[2].splice(0, hour)

            this.allA = allA
        }
    },
    methods:{
        tabTitle(transform){
            this.transform = transform.loopName
            this.loopUrl = transform.loopUrl.substr(transform.loopUrl.indexOf('/') + 1)
            console.log(this.loopUrl);
            this.showList = false
        },
        showTransformList(){
            this.showList = !this.showList
        },
        // 根据区域获取当前的进线再获取三相电流
        async getIntoLine(){
            let time = getTodayTime()
            let res = await this.$http.loopMasterArea({areaId:this.$store.state.siteId})
            this.loop = res.data.data.loop
            this.transformList.push(this.loop)
            // console.log(this.transformList);

            let arr = ['Ia_1h','Ib_1h','Ic_1h']
            for(let i = 0;i <arr.length;i++){
                let data = {
                    deviceLoopId :this.loop.loopId,
                    node:arr[i],
                    start:`${time}T00:00:00Z`,
                    end:`${time}T24:00:00Z`
                }
                let result = await this.$http.loopHistorycurve(data)
                // console.log(result);
                let ia = result.data.data.points.map(item => {
                   return  item = (Number(item.val)).toFixed(2)
                })
                // this.allA.push(ia)
                this.$set(this.allA,i,ia)
            }
            console.log(this.allA);
            this.tabTitle(this.transformList[0])
            
        },

    }
}
</script>

<style lang="less" scoped>
    .transformer{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 64.4vh;
        left: 2vw;

        .echarts{
            position: relative;
            height: 28.7vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .tabList{
                font-size: 14rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: rgba(230,243,253, 0.7);
                position: absolute;
                right: 1vh;
                top: 1vh;
                cursor: pointer;
            }

            .list{
                height: 10.5vh;
                width: 100%;
                position: absolute;
                left: 0;
                top: 3.2vh;
                z-index: 11;
            }

            .edata{
                height: 9vh;
                display: flex;
                justify-content: space-evenly;
                padding: 3vh 0;
                .edataCon{
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                        &>span{
                            display: inline-block;
                            width: 12rem;
                            height: 12rem;
                            margin-right: 0.2vw;
                        }
                        .span1{
                            background-color: #df375b;
                        }
                        .span2{
                            background-color: #ffcd8b;
                        }
                        .span3{
                            background-color: #5ad8ce;
                        }
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                }
            }

            .eview{
                width: 100%;
                padding: 0 0.5vw;
                height: 17.9vh;
                position: relative;
                #intoLineChart{
                    width: 100%;
                    height: 100%;
                }

                .noneData{
                    display: inline-block;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    color: rgba(230,243,253, 0.7);
                    transform: translate(-50% , -50%);
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>